import { axiosRequest } from '@planbord/axios-request';
import { useQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';
import { ScheduleGroup } from '@planbord/shared/models';
export const useGetDashboard = () => {
  const baseUrl = '/api';

  const datetime = ref('');
  const hideOldSchedules = ref();

  const query = useQuery<ScheduleGroup[]>({
    queryKey: ['getDashboard', datetime, hideOldSchedules],
    enabled: computed(
      () => datetime.value !== '' && hideOldSchedules.value !== undefined
    ),
    queryFn: () =>
      axiosRequest
        .get(`${baseUrl}/dashboard/${datetime.value}`, {
          params: { hideOldSchedules: hideOldSchedules.value },
        })
        .then((res) => res.data),
  });

  return {
    ...query,
    datetime,
    hideOldSchedules,
  };
};
